import { render, staticRenderFns } from "./ProductDeta.vue?vue&type=template&id=6a0442aa&scoped=true"
import script from "./ProductDeta.vue?vue&type=script&lang=js"
export * from "./ProductDeta.vue?vue&type=script&lang=js"
import style0 from "./ProductDeta.vue?vue&type=style&index=0&id=6a0442aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0442aa",
  null
  
)

export default component.exports